import {useMemo} from 'react';
import {matchPath, useLocation} from 'react-router-dom';

export const useIsConfirmationPage = () => {
    const location = useLocation();

    const isConfirmationPage = useMemo(() => {
        if (matchPath('/v2/job/:jobId/confirmation', location.pathname)) {
            return true;
        }

        return false;
    }, [location]);

    return {
        isConfirmationPage,
    };
};
